import type { FaireProductEntity } from "../../entity_types/product";

export const p_9j5p73jqhn: FaireProductEntity = {
  token: "p_9j5p73jqhn",
  type: "product",
  name: "Rejoice in the Lord Charm Necklace | Christian Jewelry",
  brandToken: "b_jam4m79k4y",
  brandName: "Wild Dogwood Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/c74381ca864cf54e2f570394fe53e65ff66f43db58303f8e75bac6c6470852f4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/29f68ce2ccc948151e2fd01a8e0657ca8b6e92a8350b568b8b8679e6da84692d.png",
    "https://cdn.faire.com/fastly/703f4e145c29902fcb3c0e54b7b0881038843eedca0b5193c05128df2914a013.png",
    "https://cdn.faire.com/fastly/b48b0ced401f654eab830a86ba79019fcecaebebbb06a7d8d486c584171c2de6.png",
  ],
  priceDollars: 10.05,
  description:
    "This charming necklace features a playful daisy design that reminds the wearer to embrace positivity and find delight in every moment. The stainless steel chain is hypoallergenic and tarnish-resistant making it one of the safest metals for people with sensitive skin. \n\nChain Material: Gold-plated stainless steel (hypoallergenic, tarnish-resistant, nonfading)\nPendant: Zinc alloy, enamel\nNecklace Length: 17.9 inch chain (excluding extender) + 50mm attached extender\nDisplay Card: Printed on matte - 45 lb. photo paper cardstock, 3 x 4 inches\nPacking: Fitted cellophane sleeve for each necklace \n\nPhilippians 4:4: Rejoice in the Lord always; again I will say, rejoice!",
  tags: [],
  msrpDollars: 20.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:02.039Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
